import { Link } from "react-router-dom";
import { HardHat, Briefcase, Store, Truck, Car, CreditCard, Landmark, FileSignature, ArrowRight } from "lucide-react";
import { SectionTitle } from "./ConfianceTop";

const PARTNERS = ["AXA", "Allianz", "Generali", "Swiss Life", "APRIL", "Airbag", "Tetris", "Spring Assur"];

export const Partners = () => (
  <section className="bg-slate-50" data-testid="confiance-partners">
    <div className="max-w-6xl mx-auto px-5 py-16 md:py-20">
      <SectionTitle kicker="Nos partenaires" title="Les compagnies avec lesquelles nous travaillons" />
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {PARTNERS.map((p) => (
          <div key={p} className="h-20 rounded-xl bg-white border border-slate-200 flex items-center justify-center text-lg font-bold text-[#0A1864] tracking-tight"
            data-testid={`partner-${p.toLowerCase().replace(/\s+/g, "-")}`}>{p}</div>
        ))}
      </div>
    </div>
  </section>
);

const SPECIALTIES = [
  { icon: HardHat, label: "RC décennale", to: "/devis/rc-decennale" },
  { icon: Briefcase, label: "RC professionnelle", to: "/professionnels" },
  { icon: Store, label: "Multirisque pro", to: "/devis/multirisque-pro" },
  { icon: Truck, label: "Flotte automobile", to: "/professionnels" },
  { icon: Car, label: "VTC", to: "/professionnels" },
];

export const Specialties = () => (
  <section className="max-w-6xl mx-auto px-5 py-16 md:py-20" data-testid="confiance-specialties">
    <SectionTitle kicker="Nos spécialités" title="L'assurance des professionnels, c'est notre métier" />
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
      {SPECIALTIES.map(({ icon: Icon, label, to }) => (
        <Link key={label} to={to} data-testid={`specialty-${label.toLowerCase().replace(/\s+/g, "-")}`}
          className="group rounded-2xl bg-[#0A1864] text-white p-6 flex lg:flex-col items-center lg:items-start gap-4 hover:bg-[#102692] transition-colors">
          <Icon className="w-7 h-7 text-[#F97316]" />
          <span className="font-semibold flex-1">{label}</span>
          <ArrowRight className="w-4 h-4 opacity-60 group-hover:translate-x-1 transition-transform" />
        </Link>
      ))}
    </div>
  </section>
);

export const SecurePayment = () => (
  <section className="bg-[#0A1864] text-white" data-testid="confiance-payment">
    <div className="max-w-6xl mx-auto px-5 py-16 md:py-20 grid gap-10 md:grid-cols-2 items-center">
      <div>
        <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#F97316]">Paiement sécurisé</p>
        <h2 className="mt-2 text-2xl md:text-3xl font-bold">Carte ou prélèvement SEPA via Stripe.</h2>
        <p className="mt-4 text-white/80">Contrat émis uniquement après signature et paiement.</p>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {[[CreditCard, "Carte bancaire"], [Landmark, "Prélèvement SEPA"], [FileSignature, "Signature électronique"]].map(([Icon, t]) => (
          <div key={t} className="rounded-2xl bg-white/10 border border-white/15 p-4 text-center">
            <Icon className="w-7 h-7 mx-auto" />
            <p className="mt-2 text-xs sm:text-sm">{t}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
